// @app/modules/duck/actions.jsx
import { createActions } from 'reduxsauce';

const { Creators, Types } = createActions({
    appHandleMessage: ['messageText', 'messageType', 'messageTitle'],
    saveModulePhrases: ['moduleId', 'lang', 'phrases']
});

export { Creators, Types };